module.exports = __webpack_public_path__ + "img/s2-title.2dec23df.png";